import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectContentBlock } from '../selectors/content-block.selectors';
import { filter } from 'rxjs';
import { contentBlockActions } from '../actions/content-block.actions';

@Injectable({
    providedIn: 'root',
})
export class ContentBlockFacade {
    private readonly store = inject(Store);

    readonly contentBlock$ = (id: string) => this.store.select(selectContentBlock(id));
    readonly contentBlockNonNullable$ = (id: string) => this.store.select(selectContentBlock(id)).pipe(filter(Boolean));

    getContentBlock(id: string): void {
        this.store.dispatch(contentBlockActions.getContentBlock({ id }));
    }

    clear(): void {
        this.store.dispatch(contentBlockActions.clear());
    }
}
